module.exports = "<span class=\"right\">v {{rev}}</span>\r\n\r\nmccomp.pl &copy;{{now}}\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/footer/footer/footer.component.html
// module id = ../../../../../src/app/pages/shared/footer/footer/footer.component.html
// module chunks = main